import { useMemo } from 'react';
import { useGetProviders } from 'react-easyrocket';
import { useSearchParams } from 'react-router';

export function useGetProviderFromUrl() {
  const [searchParams] = useSearchParams();

  const providerId = useMemo(() => {
    const providerIdFromUrl = searchParams.get('providerId');
    if (!providerIdFromUrl) return undefined;
    return parseInt(providerIdFromUrl, 10);
  }, [searchParams]);

  const { providers: allProviders, isLoading: loadingProviders } = useGetProviders(
    { per_page: 9000 },
    { enabled: Boolean(providerId) }
  );

  const providerTitle = useMemo(() => {
    if (!providerId) return undefined;
    return allProviders?.find((provider) => provider.id === providerId)?.name;
  }, [providerId, allProviders]);

  return { providerId, providerTitle, loadingProviders };
}
